import { Component, Input } from '@angular/core';

import { OverAskConfig } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';

import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { BetslipOverAskActions } from '../actions';
import { IBetslipOverAskPickListProps } from '../models/over-ask.model';
import { OverAskMessagesProvider } from '../services/over-ask-messages.provider';
import { OverAskTrackingActions } from '../tracking.actions';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPendingBaseComponent {
    @Input() pickListProps: IBetslipOverAskPickListProps;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    overAskFlowState = OverAskFlowState.Pending;

    progressBarStep = 5;
    overAskTimeout = 50000;
    pauseThreshold = 80;
    pauseProgressBar = false;
    shouldShowPercentage = false;

    messages: {
        reviewTitle: string;
        reviewInformation: string;
        progressBarInfoText: string;
        cancelButtonTitle: string;
    };

    constructor(
        private store: Store,
        overAskConfig: OverAskConfig,
        overAskMessagesProvider: OverAskMessagesProvider,
    ) {
        this.progressBarStep = overAskConfig.reviewProgressbarTotalSteps || this.progressBarStep;
        this.overAskTimeout = overAskConfig.reviewWaitingTime || this.overAskTimeout;
        this.shouldShowPercentage = overAskConfig.pendingShouldShowPercentage;
        this.pauseThreshold = overAskConfig.pauseThreshold || this.pauseThreshold;

        this.messages = {
            reviewTitle: overAskMessagesProvider.messages.pendingTitle,
            reviewInformation: overAskMessagesProvider.messages.reviewInfoMessage,
            progressBarInfoText: overAskMessagesProvider.messages.pendingCheckingYourBet,
            cancelButtonTitle: overAskMessagesProvider.messages.cancel,
        };
    }

    cancelOverAsk(): void {
        this.store.dispatch(BetslipOverAskActions.userRequestRejectOffer());
        this.store.dispatch(OverAskTrackingActions.trackClose({ method: 'cancel' }));
    }

    onProgress(value: number): void {
        this.pauseProgressBar = value >= this.pauseThreshold;
    }
}
